import styled from 'styled-components';
import worldcupstatus from "../../../../assets/images/worldcup_status.png";

const FailedWrapper = styled.div`
.payment-details-wrapper{
    color: #4c565c;
    margin: 0 auto;
    padding: 3rem;
    text-align: center;
    img{
      margin-bottom: 2rem;
      height: 100px;
    }
    h2{
      font-size: 2.25rem;
      font-weight: bold;
      margin-bottom: 1.25rem;
    }
    p{
      font-size: 1.75rem;
      margin-bottom: 1.75rem;

    }
}
.worldcup_success_wrapper {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  overflow: hidden;
  border-radius: 10px;
  margin-top: 5rem;
  margin-bottom: 5rem;
  width: 800px;
  margin: auto;
  box-shadow: 0px 1px 10px 5px #f4f4f4;

  .worldcup_banner {
    p, h5 {
      margin: 0;
    }
    h5 {
      font-size: 1.3rem;
    }
    p {
      font-size: 0.8rem;
    }
    img {
      height: unset;
      margin-bottom: unset;
    }
    background-image: url(${worldcupstatus});
    width: 800px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    align-items: center;
    color: #ffffff;
    padding: 2rem 3rem;
    text-align: left;

    div {
      margin: 0 10px;
      // padding: 1rem 0;
    }
  }
  .header-wrapper {
    .image {
      img {
        height: 50px;
      }
    }
    .text {
      h2 {
        font-size: 1.5rem;
      }
      .smaller {
        font-size: 0.9rem;
        margin-top: -1rem;
      }
    }
  }
}
`;

export default FailedWrapper;